import React              from 'react';
import useStyles          from './resetPasswordFormStyles';
import { useTranslation } from 'react-i18next';

import Box       from '@mui/material/Box';
import Button    from '@mui/material/Button';
import Grid      from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tooltip   from '@mui/material/Tooltip';

import PropTypes from 'prop-types';

export const NEW_PASSWORD_FIELD_NAME    = 'new-password';
export const PASSWORD_REPEAT_FIELD_NAME = 'new-password-repeat';


function ResetPasswordForm(props) {

  const { t }       = useTranslation();
  const { classes } = useStyles();

  const [fieldErrors, setFieldErrors] = React.useState({});

  function clearFieldError(fieldName) {
    setFieldErrors(prevState => {
      const newState      = { ...prevState };
      newState[fieldName] = false
      return newState;
    })
  }

  /**
   * This handler is run separately for each invalid field.
   */
  function handleInvalid(evt) {
    //corresponds to name attribute inside the <form>
    const invalidFieldName = evt.target.name;
    setFieldErrors(prevState => {
      const newState             = { ...prevState };
      newState[invalidFieldName] = true
      return newState;
    })
  }

  function fieldProps(fieldName) {
    return {
      required:  true,
      type:      'password',
      name:      fieldName,
      fullWidth: true,
      className: classes.field,
      error:     fieldErrors[fieldName],
      disabled:  props.disabled,
      onChange:  () => clearFieldError(fieldName)
    };
  }

  let tooltipTitle = '';
  if (props.isInProgress)
    tooltipTitle = t('inProgress');

  //TODO add icons as end adornments

  return (
    <Box component='form' onSubmit={props.onSubmit} onInvalid={handleInvalid}>
      <Grid
        container
        direction='column'
        spacing={3}
        paddingTop={2}
        paddingBottom={3}
        paddingLeft={4}
        paddingRight={4}
        justifyContent='center'
        alignItems='stretch'
      >
        <Grid item>
          <TextField
            {...fieldProps('username')}
            value={props.email}
            disabled
            type='text'
            label={t('usernameFieldLabel')}
          />
        </Grid>
        <Grid item>
          <TextField
            {...fieldProps(NEW_PASSWORD_FIELD_NAME)}
            label={t('passwordFieldLabel')}
          />
        </Grid>
        <Grid item>
          <TextField
            {...fieldProps(PASSWORD_REPEAT_FIELD_NAME)}
            label={t('repeatPasswordFieldLabel')}
          />
        </Grid>
        <Grid item>
          <Tooltip title={tooltipTitle}>
              <span> {/*//Disabled elements can't hold a ref required by Tooltip*/}
                <Button
                  type="submit"
                  fullWidth
                  disabled={props.isInProgress || props.disabled}
                >
                  {t('resetPasswordTitle')}
                </Button>
              </span>
          </Tooltip>
        </Grid>
      </Grid>
    </Box>
  );
}

ResetPasswordForm.propTypes = {
  onSubmit:     PropTypes.func.isRequired,
  isInProgress: PropTypes.bool,
};

export default ResetPasswordForm;